(function (angular) {
	'use strict';

	angular
		.module('investorUpdatesModule', [
			'apiModule',
			'collapseModule',
			'coreModule',
			'localStorageModule',
			'mediaGalleryModule',
			'portfolioAllocationChartModule',
			'reitElementListingModule',
			'riskAdjustedReturnModule'
		])
		.value('globalConfig', globalConfig);
})(window.angular);